// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Rnkj","type":"styles_type__1qDhA","choices":"styles_choices__1wir9"};